export default __webpack_public_path__ + "static/media/domki5.68011e79.jpg";